export const getOrgStructure = (payload?: any) => ({
    type: "@saga/GET_ORGSTRUCTURE",
    payload
});

